import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ClosedPlanView, ClosedPlanViewDefaultValues } from 'src/app/components/participants/plans/plan';
import { ApplicationRoles } from 'src/app/components/users/user-roles';
import { AuthService } from 'src/app/services/auth.service';
import { ModalService } from 'src/app/services/modal.service';
import { ParticipantThemeService } from 'src/app/services/participant-theme.service';
import { PlanService } from 'src/app/services/plan.service';
import { ToastService } from 'src/app/services/toast-service.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-view-plan',
    templateUrl: './view-plan.component.html',
    styleUrls: ['./view-plan.component.scss'],
    standalone: false
})
export class ViewPlanComponent {

  closedPlanView:ClosedPlanView = ClosedPlanViewDefaultValues();
    participantClassByRole: string = '';
    translations: any;
    llttfPage: boolean = false;
    modalSub!: Subscription;

    modalOpen = this._modalservice.getModalState();
    modalContent = '';
    modalTitle = '';
    modalOkButtonValue = 'OK';
    modalCancelButtonValue = 'CANCEL';
    modalOkButtonText = 'Ok';
    modalCancelButtonText = 'Cancel';

  constructor(private _planservice: PlanService,
    private route: ActivatedRoute,
    private router: Router,
    private authservice: AuthService,
    private translationservice: TranslationService,
    private themeService: ParticipantThemeService,
    private _modalservice: ModalService,
    private _toastservice: ToastService
  ){}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const planPublicId = params['planid'] ?? '';
      this._planservice.viewPlan(planPublicId).subscribe({
        next: (data) => {
          this.closedPlanView = data;
        }
      });
    });

    this.translationservice.getTranslation().subscribe({
      next:(value)=> {
        this.translations = value;
        this.modalCancelButtonText = value['cancelButtonText'] || this.modalCancelButtonText;
      },
    });

    this.themeService.setParticipantTheme();
    this.participantClassByRole = this.themeService.participantClassByRole;
    this.llttfPage = this.themeService.llttfPage;

    this.afterConfirmModalOps();
  }

  navigate(url:string) {
    this.router.navigateByUrl(url)
  }

  getScheduleLabel(value: string | undefined): string {
    if (!value || !this.translations) {
      return value || '';
    }
    const scheduleMap: Record<string, string> = {
      'Today': 'scheduleTodayText',
      'Tomorrow': 'scheduleTomorrowText',
      'Daily': 'scheduleDailyText',
      'Weekly': 'scheduleWeeklyText',
      'Monthly': 'scheduleMonthlyText',
      'Specify Date': 'scheduleSpecifyDateText',
    };
    // Reminder frequency may include day of week after the schedule word, e.g. "Weekly Monday"
    for (const [english, key] of Object.entries(scheduleMap)) {
      if (value === english || value.startsWith(english + ' ')) {
        const translated = this.translations[key] || english;
        return value.replace(english, translated);
      }
    }
    return value;
  }

  askConfirmation (
    okButtonText: string,
    okButtonValue: string,
    cancelButtonText: string,
    cancelButtonValue: string,
    content: string,
    title: string
  ) {
    this.modalContent = content;
    this.modalTitle = title;
    this.modalOkButtonValue = okButtonValue;
    this.modalCancelButtonValue = cancelButtonValue;
    this.modalOkButtonText = okButtonText;
    this.modalCancelButtonText = cancelButtonText;

    this._modalservice.openModal();
  }

  afterConfirmModalOps() {
    this.modalSub = this._modalservice
      .getButtonClicked()
      .subscribe((button) => {
        switch (button) {
          case 'YES':
            this._planservice.deletePlan(this.closedPlanView.id).subscribe({
              next: (response: any) => {
                this._toastservice.showMessage(this.translations?.['planDeletedSuccessText'] || "Plan Deleted Successfully");
                this.router.navigate(['/dashboard-participant']);
              }
            })
          break;
          default:
            this._modalservice.closeModal();
        }
      });
  }

  ngOnDestroy(): void {
    if (this.modalSub) {
      this.modalSub.unsubscribe();
    }
  }

  deletePlan() {
    this.askConfirmation(
      this.translations?.['deletePlanConfirmYesText'] || "Yes, Delete",
      'YES',
      this.translations?.['deletePlanConfirmNoText'] || 'No, Cancel',
      'NO',
      this.translations?.['deletePlanConfirmContentText'] || 'Are you sure you want to permanently delete this plan?',
      this.translations?.['deletePlanConfirmTitleText'] || 'Delete Plan'
    );
  }
}
